export const filterBarTrackingSource = 'filterbar';
